import serviceProyecto from '@/services/GsEncuesta/proyecto'

export default {
  PROYECTO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PROYECTO_FIND_ALL_BY_USUARIO(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.findAllByUsuario(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PROYECTO_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PROYECTO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PROYECTO_FIND_LOGO(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.findLogo(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PROYECTO_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceProyecto.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
